import React from "react";
import {string, array} from "prop-types";

const OrderSummary = ({
    title,
    children
}) => {
    return(
        <div className="OrderSummary">
            <h4>{title}</h4>
            <table key="details" className="table">
                <tbody>
                    {children}
                </tbody>
            </table>
        </div>
    );
};

OrderSummary.defaultProps = {
    title: "Order Summary"
};

OrderSummary.propTypes = {
    title: string,
    children: array
};

export default OrderSummary;